export default __webpack_public_path__ + "static/media/610.fb171cd7.png";